import React, { useEffect, useState } from "react";
import axios from "axios";
import type { AutoCompleteProps, FormProps } from 'antd';
import { AutoComplete, Button, Card, Col, Flex, Form, Input, Modal, Progress, Radio, Row, Segmented, Spin, message } from 'antd';
import logo from './img/VULOGO.png'
import { ConfigProvider } from 'antd';
import {  LoadingOutlined, LockOutlined,  UserOutlined } from "@ant-design/icons";
import { App } from 'antd';
import R from './img/homepage.jpg'

export function InsiderSignIn(){
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [role, setRole] = useState('staff');
    const [RegisteredMod,setRegisteredMod] = useState(false);
    const [ForgottenMod,setForgottenMod] = useState(false);
    const [loading,setLoading]=useState(false);
    const [successReset,setsuccessReset]=useState(false);
    const [FailedReset,setFailedResetReset]=useState(false);
    const [status,setstatus] = useState('')
    const [RegistrationForm] = Form.useForm();
    const [ForgotForm] = Form.useForm();

    const { message, notification } = App.useApp();

    const [isFormValid, setIsFormValid] = useState(false);

    type FieldType = {
        username?: string;
        password?: string;
    };

    const fetchimg = async (user:any) =>{
        try{
            console.log(user)
            await axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${user}`).then(res=>
            { 
              if(res.data){
                console.log(res.data)
                sessionStorage.setItem("user_picture",res.data.userResult[0].picture)
              }else{
                sessionStorage.setItem("test","test")
              }
            }
              
            )}catch (error) {
                console.error("Error fetching position role", error);
            }
    }

    const fetchifStaff = async (departments:any)=>{
        const availablePositions = [];
            for(const department of departments){
                if(department.Fac_ID==112){
                    availablePositions.push(department);
                } 
            }
            return availablePositions; 
    }

    
    const Login: FormProps<FieldType>['onFinish'] = async (values) => {
        const data = { username: values.username, password: values.password };
        try{
            if (role === 'commitee' && data.username) {
                console.log('committee');
                try {
                    // try digitalId login first
                    const response = await axios.post("https://i.vu.ac.th/digitalId/vuapiver1/auth/login.php", data);
                    if (response.status === 200) {
                        const { token, user_id, fullname, user_type } = response.data;
            
                        const resp = await axios.get(`${process.env.REACT_APP_BASE}/checkCommitteeList/${user_id}`);
                        if (resp.status === 200 && resp.data.length !== 0) {
                            sessionStorage.setItem("token", token);
                            sessionStorage.setItem("user", user_id);
                            sessionStorage.setItem("fullname", fullname);
                            sessionStorage.setItem("user_type", user_type);
            
                            sessionStorage.setItem("role", "committee");
                            sessionStorage.setItem("CommitteeID", resp.data[0].CommitteeID);
                            sessionStorage.setItem("isInsider", resp.data[0].isInsider);
            
                            setTimeout(() => window.location.reload(), 500);
                        } else {
                            message.error("คุณไม่มีสิทธิ์ล็อคอินเข้าสู่ระบบในฐานะกรรมการ");
                        }
                    }
                } catch (error) {
                    // if first login fails, try second one
                    try {
                        const res = await axios.post(`${process.env.REACT_APP_BASE}/auth/CommitteeLogin`, data);
                        if (res.status === 200) {
                            console.log(res.data.data)
                            const { token, UserID, CommitteeName,  } = res.data.data;
            
                            const resp = await axios.get(`${process.env.REACT_APP_BASE}/checkCommitteeList/${UserID}`);
                            if (resp.status === 200 && resp.data.length !== 0) {
                                sessionStorage.setItem("token", token);
                                sessionStorage.setItem("user", UserID);
                                sessionStorage.setItem("fullname", CommitteeName);
            
                                sessionStorage.setItem("role", "committee");
                                sessionStorage.setItem("CommitteeID", resp.data[0].CommitteeID);
                                sessionStorage.setItem("isInsider", resp.data[0].isInsider);
            
                                setTimeout(() => window.location.reload(), 500);
                            } else {
                                console.log('error founded')
                                message.error("คุณไม่มีสิทธิ์ล็อคอินเข้าสู่ระบบในฐานะกรรมการ");
                            }
                        }
                    } catch (err) {
                        notification.error({
                            message: "เข้าสู่ระบบไม่สำเร็จ",
                        });
                    }
                }
            }
            else{
                const response = await axios.post("https://i.vu.ac.th/digitalId/vuapiver1/auth/login.php", data);
                if (response.status === 200){
                    const { department, token, user_id, fullname, user_type } = response.data;
                    if(role === 'staff'){
                        const availablePositions = await fetchifStaff(department);
                        if (availablePositions.length === 0) {
                            message.error("คุณไม่มีสิทธิ์ล็อคอินเข้าสู่ระบบในฐานะเจ้าหน้าที่");
                            return;
                        }
    
                        await fetchimg(user_id);
                        sessionStorage.setItem("token", token);
                        sessionStorage.setItem("user", user_id);
                        sessionStorage.setItem("fullname", fullname);
                        sessionStorage.setItem("user_type", user_type);
    
                        sessionStorage.setItem("role", 'staff');
                        sessionStorage.setItem("POS_ID", JSON.stringify(availablePositions));
                        sessionStorage.setItem("Fac_ID", availablePositions[0].Fac_ID);
                        setSuccess(true);
                        setTimeout(() => {
                            window.location.reload();
                        }, 500); 
                    }else if(role === 'president'){
                        axios.get(`${process.env.REACT_APP_BASE}/checkIsPresident/${user_id}`).then(async resp =>{
                            console.log(resp.data)
                            if(resp.status === 200&&resp.data.length!=0){
                                await fetchimg(user_id);
                                sessionStorage.setItem("token", token);
                                sessionStorage.setItem("user", user_id);
                                sessionStorage.setItem("fullname", fullname);
                                sessionStorage.setItem("user_type", user_type);
        
                                sessionStorage.setItem("role", 'president');
                                sessionStorage.setItem("POS_ID", JSON.stringify(department));
        
                                setSuccess(true);
                                setTimeout(() => {
                                    window.location.reload();
                                }, 500); 
                            }else{
                                message.error(`คุณไม่มีสิทธิ์ล็อคอินเข้าสู่ระบบในฐานะประธาน`);
                                return;
                            }
                        })
                        
                     
                    }else if(role === 'commitee'){
                        axios.get(`${process.env.REACT_APP_BASE}/checkCommitteeList/${user_id}`).then(resp =>{
                            if (resp.status === 200){
                                if(resp.data.length!=0){
                                    sessionStorage.setItem("token", token);
                                    sessionStorage.setItem("user", user_id);
                                    sessionStorage.setItem("fullname", fullname);
                                    sessionStorage.setItem("user_type", user_type);
        
                                    sessionStorage.setItem("role", 'committee');
                                    sessionStorage.setItem("POS_ID", JSON.stringify(department||[]));
                                    sessionStorage.setItem("CommitteeID", resp.data[0].CommitteeID);
                                    sessionStorage.setItem("isInsider", resp.data[0].isInsider)
    
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 500); 
                                }else{
                                    message.error("คุณไม่มีสิทธิ์ล็อคอินเข้าสู่ระบบในฐานะกรรมการ");
                                    return;
                                }
                            }
                        })
                    }
                    else{
                        console.log(role)
                    }
                }
            }
    
        }
        catch (error) {
            setError(true);
            notification.error({
                message: "เข้าสู่ระบบไม่สำเร็จ",
            });
        }
    }
    return <>
        <ConfigProvider
            theme={{
                components: {
                    Form: { labelColor: 'black' },
                    Segmented: {
                        itemActiveBg: '#D4BDAC',
                        itemSelectedBg: '#FFF1DB',
                        trackBg: 'gray',
                        // itemColor: 'white',
                    },
                },
                token: { fontFamily: 'Kanit' },
            }}>
            <title>VU HREC</title>
            <link rel="icon" type="image/png" href={logo} />
           
            <div
            style={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // backgroundColor:'beige',
                backgroundImage: `url(${R})`,
                backgroundSize: '100% 100%',  
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
        > <div
        style={{
            height: '100vh',
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor:'rgba(255, 255, 255, 0.7)',
            // backgroundImage: `url(${R})`,
            backgroundSize: '100% 100%',  
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }}
    >
         <Card
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
                <h1 style={{marginBottom:0}}>เข้าสู่ระบบ</h1>
                <h3 style={{marginTop:0}}>ยินดีต้อนรับเข้าสู่ระบบยื่นขอพิจารณาจริยธรรมวิจัย</h3>
                <h3>กรุณาเลือกสถานะ</h3>
                <Flex justify="center">
                    <Segmented
                        style={{
                        backgroundColor: 'white',
                        }}
                        options={['เจ้าหน้าที่สำนักงานจริยธรรม', 'ประธาน',  'คณะกรรมการ']}
                        onChange={(value) => {
                         if (value == 'เจ้าหน้าที่สำนักงานจริยธรรม') {
                            setRole('staff');
                        } else if (value == 'ประธาน') {
                            setRole('president');
                        } else {
                            setRole('commitee');
                        }
                        }}
                    />
                </Flex>
                <Form
                    className="text-white"
                    name="basic"
                    onFinish={Login}
                    layout={'vertical'}
                    >
                    <Form.Item<FieldType>
                        name="username"
                        rules={[{ required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน' }]}>
                        <Input
                            size="large"
                            placeholder="ชื่อผู้ใช้งาน"
                            prefix={<UserOutlined />}
                        />
                    </Form.Item>
                    <Form.Item<FieldType>
                        name="password"
                        rules={[{ required: true, message: 'กรุณากรอกรหัส' }]}
                        >
                        <Input.Password
                            size="large"
                            prefix={<LockOutlined />}
                            placeholder="รหัสผ่าน"
                        />
                    </Form.Item>
                    <Button
                        size="large"
                        style={{ width: 350, color: 'white', backgroundColor: '#024f4a' }}
                        type="primary"
                        htmlType="submit"
                    >
                        <p className="text-xl">เข้าสู่ระบบ</p>
                    </Button>
                </Form>
                <Flex vertical justify="center" align="center" style={{ margin: 0, gap: 0 }}>
                    <p style={{ margin: 5 }}>หมายเหตุ : สำหรับบุคลากรภายใน ให้ใช้รหัสตาม VUFamily</p>
                    <p style={{ margin: 5 }}>สำหรับบุคคลภายนอกให้ใช้บัญชีตามที่ท่านได้รับแจ้งในเมลของท่าน</p>
                    <p>ต้องการเข้าสู่ระบบในฐานะนักวิจัย? <a onClick={()=>{
                        sessionStorage.clear();
                        window.location.reload();}
                    }>คลิ๊กที่นี่</a></p>
                </Flex>
                <Flex vertical justify="center" align="center" style={{ margin: 5, gap: 0 }}>
                <a target='_blank' href="https://drive.google.com/file/d/19-1hMK5pvAo4P2hTPnWS59mvMfBZQk7I/view?usp=drive_link"><Button>คู่มือการใช้งานสำหรับเจ้าหน้าที่</Button></a>
                </Flex>
                <Flex vertical justify="center" align="center" style={{ margin: 5, gap: 0 }}>
                <a target='_blank' href="https://drive.google.com/file/d/1veMf-QO_F-zLEvkfo10_t3E_NfUZAOHJ/view?usp=drive_link"><Button>คู่มือการใช้งานสำหรับประธาน</Button></a>
                </Flex>
                <Flex vertical justify="center" align="center" style={{ margin: 5, gap: 0 }}>
                <a target='_blank' href="https://drive.google.com/file/d/1ocqgJq8mBLItWXeH-MPvJK1Z-pQlrkQu/view?usp=drive_link"><Button>คู่มือการใช้งานสำหรับคณะกรรมการ</Button></a>
                </Flex>

                                
            </Card>
    </div>
           
        </div>
        </ConfigProvider>
    </>
}